import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/operators';
import { ActivityLoggerService } from 'src/app/_shared/service/activity-logger.service';
import constant from 'src/constant.json';
import { MyHomeService } from '../../service/my-home.service';
import { MyHomeState } from '../../state/my-home.state';

@Component({
  selector: 'app-create-refinance-mortgage-scenario-dialog',
  templateUrl: './create-refinance-mortgage-scenario-dialog.component.html',
  styleUrls: ['./create-refinance-mortgage-scenario-dialog.component.scss'],
})
export class CreateRefinanceMortgageScenarioDialogComponent implements OnInit {
  createLoanForm: FormGroup;
  isEquityAnalysis: boolean;
  private onDestroyNotifier: Subject<any> = new Subject<any>();
  equityMortgageList: any;
  constructor(
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data,
    private dialogRef: MatDialogRef<CreateRefinanceMortgageScenarioDialogComponent>,
    private myHomeState: MyHomeState,
    private myHomeService: MyHomeService,
    private activityLoggerService: ActivityLoggerService,
    private router: Router
  ) { }

  ngOnInit(): void {
    const path = this.router.url.split('?')[0];
    if (path?.includes('equity-analysis')) {
      this.isEquityAnalysis = true;
    }

    this.createLoanForm = this.formBuilder.group({
      interest: ['', [Validators.required, Validators.min(1), Validators.max(15)]],
      termYear: ['', [Validators.required, Validators.min(1), Validators.max(30)]],
      termMonth: ['', [Validators.required, Validators.min(0), Validators.max(11)]],
      closingCost: [''],
    });

    this.myHomeState.mortgageList$.pipe(takeUntil(this.onDestroyNotifier)).subscribe((data) => {
      if (data) {
        this.equityMortgageList = data;
      }


    });
  }

  onSubmit() {
    if (!this.createLoanForm.valid) {
      return;
    }
    let params = {
      interestRate: this.createLoanForm.value.interest,
      termBalance: this.createLoanForm.value.termYear * 12 + this.createLoanForm.value.termMonth,
      closingCost: this.createLoanForm.value.closingCost,
      isActive: false,
    };


    if (this.isEquityAnalysis) {

      this.equityMortgageList.map((mortgage) => {
        if (mortgage.temp_id === this.data.selectedMortgageData.temp_id) {
          if (
            !mortgage.refinanceScenarioList ||
            mortgage.refinanceScenarioList.length === 0
          ) {
            params['id'] = 1;
            params['name'] = 'New Loan Scenario 1';
            mortgage.refinanceScenarioList = [params];
          } else {
            const lastIndex = mortgage.refinanceScenarioList.length - 1;
            const lastElement = mortgage.refinanceScenarioList[lastIndex];

            params['id'] = lastElement.id + 1;
            params['name'] = 'New Loan Scenario ' + params['id'];

            mortgage.refinanceScenarioList.push(params);
          }
        }
      });
      this.dialogRef.close();

    } else {
      let myHomeValues = this.myHomeState?.myHomeListValue.filter((myHome) => {
        return myHome.id == this.myHomeState?.activeHomeValue?.id;
      });
      myHomeValues = myHomeValues[0];
      myHomeValues.homeId = myHomeValues?.id;
      myHomeValues.mortgageList.map((mortgage) => {
        const lastIndex = mortgage.refinanceScenarioList.length - 1;
        const lastElement = mortgage.refinanceScenarioList[lastIndex];
        if (mortgage.id === this.data.selectedMortgage) {
          if (!mortgage.hasOwnProperty('refinanceScenarioList')) {
            params['id'] = 1;
            params['name'] = 'New Loan Scenario 1';
            mortgage.refinanceScenarioList = [params];
          } else {
            params['id'] = lastElement.id + 1;
            params['name'] = 'New Loan Scenario ' + (lastElement.id + 1);
            mortgage.refinanceScenarioList.push(params);
          }
        }
      });
      this.myHomeService
        .updateMyHomeValues([myHomeValues], false)
        .pipe()
        .subscribe((res: any) => {
          if (!res.isLoading) {
            this.dialogRef.close();
          }
        });
      this.logUserActivity(constant.LOGGER.myHome.category, constant.LOGGER.myHome.action.addLoanScenario.key);
    }
  }

  logUserActivity(category, action) {
    let loggerParams = {
      category: category,
      action: action,
    };
    let inputData = {};
    this.activityLoggerService.logActivity(loggerParams, inputData);
  }

  proceedCancelAction() {
    this.dialogRef.close();
  }
  ngOnDestroy(): void {
    this.onDestroyNotifier.next();
    this.onDestroyNotifier.complete();
  }
}
